// @flow

import { LazyLoadComponent } from '@zapier/common-components';

const LazyLoadDestinationAuthModal = LazyLoadComponent({
  loader: () =>
    import(
      /* webpackChunkName: 'app-common-components-DestinationAuthModalContainer' */ 'app/common/components/DestinationAuthModalContainer'
    ),
});

export default LazyLoadDestinationAuthModal;
